import { useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { nonPostalCountries } from './country-settings';
const defaultValues = {
    address1: '',
    address2: '',
    zip: '',
    city: '',
    state: '',
    country: 'US',
};
const iceland = 'IS';
const requiredField = yup.string().required().label('This');
export const schema = yup.object().shape({
    address1: requiredField,
    address2: yup.string().default(''),
    zip: yup.string().when('country', {
        is: (country) => nonPostalCountries.includes(country),
        then: it => it.default(''),
        otherwise: it => it.required().label('This')
    }),
    city: requiredField,
    state: yup.string().when('country', {
        is: iceland,
        then: it => it.default(''),
        otherwise: it => it.required().label('This')
    }),
    country: requiredField,
});
export function useAddressForm() {
    const form = useForm({
        resolver: yupResolver(schema),
        defaultValues: defaultValues,
        mode: 'all',
    });
    const country = form.watch('country');
    useEffect(() => {
        const valuesToReset = Object.assign(Object.assign({}, defaultValues), { country });
        form.reset(valuesToReset);
    }, [country]);
    return form;
}
//# sourceMappingURL=useAddressForm.js.map